/*
 * This file is part of glowingblue/orell-articles.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import type { ComponentAttrs } from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import type Mithril from 'mithril';
import type Article from '../models/Article';
import WishlistRepository from '../WishlistRepository';

export interface WishlistActionButtonAttrs extends ComponentAttrs {
	article: Article;
}

export default class WishlistActionButton extends Component<WishlistActionButtonAttrs> {
	loading: boolean = false;

	view(): Mithril.Children {
		const { article } = this.attrs;
		if (!article?.productId()) {
			return null;
		}
		return (
			<Button
				className="Button Button--action WishlistActionButton"
				onclick={() => void new WishlistRepository().handleClick(article, this)}
				loading={this.loading || app.fof_oauth_loginInProgress || app.fof_oauth_linkingInProgress}
			>
				{app.translator.trans('glowingblue-orell-articles.forum.article.add_to_wishlist')}
			</Button>
		);
	}
}
